import { Schema } from "@effect/schema";
import { Percent } from "./percent";
import { Context } from "effect";

export type GlobalState = typeof GlobalState.Type;
export type GlobalStateEncoded = typeof GlobalState.Encoded;

export const GlobalState = Schema.Struct({
  revenueApr: Percent,
}).annotations({ identifier: "GlobalState" });

export class GlobalStateService extends Context.Tag("GlobalStateService")<
  GlobalStateService,
  GlobalState
>() {}
